import * as React from 'react';
import { PortalTopPart, PortalTwoColumnLayout } from 'components/PortalStructure';
import { translate } from 'react-i18next';
import * as c from 'models/constants';
import { IUserLanguage } from 'models/user/userlanguage';
const { connect } = require('react-redux');
import { IStore } from 'redux/IStore';
import { Link } from 'react-router';
import { IUserProfile } from 'models/user/userprofile';
import { IUserCard } from 'models/user/usercard';

interface IProps {
	t?: (key: string) => string;
	userLanguage?: IUserLanguage;
	user?: IUserProfile | IUserCard;
}

@connect(
	(state: IStore) => ({
		userLanguage: state.userLanguage,
	}),
	(dispatch) => ({
		dispatch,
	}),
)
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class ManageUserWrapper extends React.Component<IProps, {}> {
	/* RENDER */
	public render() {
		const { t, user } = this.props;
		const menu = (
			<div className="sidemenu">
				<ul>
					<li>
						<Link activeClassName="active" to="/userprofile">
							{t('Portal_LeftSideMenu_MyAccount')}
						</Link>
					</li>
					<li>
						<Link activeClassName="active" to="/user/edit/shippingaddresses">
							{t('Portal_LeftSideMenu_Shipping')}
						</Link>
					</li>
					<li>
						<Link activeClassName="active" to="/notification-settings">
							{t('Portal_LeftSideMenu_Notifications')}
						</Link>
					</li>
					<li>
						<Link activeClassName="active" to="/account">
							{t('Portal_LeftSideMenu_Account')}
						</Link>
					</li>
				</ul>
			</div>
		);

		let portalTopPart = null;
		if (user) {
			portalTopPart = <PortalTopPart item={user} />;
		}

		return (
			<div>
				{portalTopPart}
				<PortalTwoColumnLayout sideMenu={menu}>{this.props.children}</PortalTwoColumnLayout>
			</div>
		);
	}
}
export { ManageUserWrapper };
